import { useCallback } from 'react';
import { Constraints } from 'hooks/webapi/application/useConstraintsQuery';
import SkeletonSlider from './SkeleonSlider';
import Slider from 'components/Slider/Slider';
import useEventCollector from 'hooks/context/EventCollector/useEventCollector';
import CalculatorEvent from 'hooks/context/EventCollector/events/CalculatorEvent';
import { useTranslation } from 'react-i18next';

export type Props = {
  onAmountChange: (value: number) => void;
  constraints?: Constraints;
  amount?: number;
  dataTest?: string;
};

export default function Sliders({
  onAmountChange,
  constraints,
  amount,
  dataTest = 'sliders',
}: Props) {
  const { track } = useEventCollector();
  const { t } = useTranslation();

  const handleAmountChange = useCallback(
    (value: number) => {
      onAmountChange(value);
      track(
        new CalculatorEvent({
          description: 'calculator amount change',
          value,
        }),
      );
    },
    [onAmountChange, track],
  );

  return (
    <div data-test={`${dataTest}-calculator`} className="pt-12">
      {constraints ? (
        <Slider
          dataTest="amount-slider"
          min={constraints.amountInterval.min}
          max={constraints.amountInterval.max}
          step={constraints.amountInterval.step}
          value={amount ?? constraints.amountInterval.defaultValue}
          onAfterChange={handleAmountChange}
          hideAmountHeader
          units={t('calculator:amount_units')}
          heading={t('calculator:amount_slider_title')}
        />
      ) : (
        <SkeletonSlider />
      )}
    </div>
  );
}
